import React from 'react';
import PropTypes from 'prop-types';
import { Components } from '@formatic/sdk';

const SdkComponent = props => {
  const { renderer } = props;
  return <Components.Field {...props} renderer={renderer} />;
};

SdkComponent.defaultProps = {
  renderer: null,
};

SdkComponent.propTypes = {
  renderer: PropTypes.string,
};

export default SdkComponent;
